import React, {Component} from 'react';
import './modal.sass';


class Modal extends Component {


    render() {
        const {modal, closeModal, confirm} = this.props;
        const mod = modal;
        return (
            <div>

                <div className="modal">
                    <div className="modal__container">
                        <div className="modal__container__title">{mod.title}</div>
                        <div className="modal__container__description">{mod.body}</div>
                        {!mod.showButtons && <div className="all_width">
                            <button className="button_cancel" onClick={closeModal}>OK</button>
                        </div>}
                        {mod.showButtons && <div className="all_width">
                            <button className="button_cancel" onClick={closeModal}>Annulla</button>
                            <button className="button_ok" onClick={confirm}>Conferma</button>
                        </div>}
                    </div>
                </div>
            </div>
        );


    }


}

export default Modal;